<canvas #canvas id="canvas" style="height: 100%; width:100%; min-width: 500px; min-height: 200px;" [ngStyle]="{'height': Height, 'width': Width}" (click)="CanvasClick($event)">
</canvas>